import $ from 'jquery';
import _ from 'ext:lodash';
import UrlUtils from 'lib/url-utils';
import Framework from 'framework';

const noRecents = 'No recently viewed clubs.';
const recentViewedId = 'recently-viewed';
const nearestClubsId = 'nearest-clubs';

export default class ClubNav {
	constructor(ClubStore, UrlStore) {
		this.ClubStore = ClubStore;
		this.UrlStore = UrlStore;
	}

	initialize() {
		if(_.isUndefined(this.ClubStore)) {
			console.error('RecentClubs component failed to initialize ClubStore dependency');
		}

		this.recentClubs = window.ef.recentClubStore.getInitialData().clubs;
		this.currentClub = this.ClubStore.getInitialData();

		this.displayRecentClubs();
		this.updateNearestClubs();

		window.ef.recentClubStore.listen((recentClubData) => {
			this.recentClubs = recentClubData.clubs;
			this.displayRecentClubs();
		});

		this.ClubStore.listen((club)=> {
			this.currentClub = club;
			this.updateNearestClubs();
		});

		this.UrlStore.listen((clubLocation)=> {
			this.displayRecentClubs(clubLocation);
			this.updateNearestClubs(clubLocation);
		});
	}

	displayRecentClubs(locationUrl) {
		if(!locationUrl || !locationUrl.href) {
			locationUrl = Framework.global.location;
		}
		// list the recent clubs but do not show the first one
		var items = '';
		if(this.recentClubs && this.recentClubs.length >= 1) {
			for(var i = 1; i < this.recentClubs.length; i++) {
				var recentClub = this.recentClubs[i];
				var link = recentClub.link;
				link = UrlUtils.subPagePath(link, locationUrl.href, locationUrl.search);

				items = items + '<li class="m-b-sm"><a href="' + link + '">' + recentClub.name + '</a></li>';
			}
		}
		if(items) {
			document.getElementById(recentViewedId).innerHTML = items;
		}else if(!this.recentClubs || this.recentClubs.length <= 1) {
			document.getElementById(recentViewedId).innerHTML =
				'<li class="m-b-sm">' + noRecents + '</li>';
		}
	}

	updateNearestClubs(locationUrl) {
		if(!locationUrl || !locationUrl.href) {
			locationUrl = Framework.global.location;
		}
		// get the nearest clubs list
		$( '#' + nearestClubsId + ' li a' ).each(function( index ) {
			var itemPath = $( this ).attr('href');
			if(!(itemPath.startsWith('http://') || itemPath.startsWith('https://'))){
				$( this ).attr('href', UrlUtils.subPagePath($( this ).attr('href'), locationUrl.href, locationUrl.search));
			}
		});
	}
}

if(!String.prototype.startsWith) {
	String.prototype.startsWith = function(searchString, position) { // eslint-disable-line no-extend-native
		var lposition = position || 0;
		return this.indexOf(searchString, lposition) === lposition;
	};
}
